import {DPLayerMapping, MappingV11Value} from '../dynamicParameters.types';
import {SourceLayerParam} from '../dynamicParameters.enums';

function getMappingParam(
  mappingObj: DPLayerMapping,
  param: SourceLayerParam,
): MappingV11Value | null {
  const data: Partial<Record<SourceLayerParam, MappingV11Value | null>> = {
    [SourceLayerParam.TextSource]: mappingObj.txtData?.parts?.[0]?.val,
    [SourceLayerParam.ColorOverlay]: mappingObj.colorOverlay,
    [SourceLayerParam.ImageSource]: mappingObj.url,
    [SourceLayerParam.VideoSource]: mappingObj.url,
    [SourceLayerParam.AudioSource]: mappingObj.url,
    [SourceLayerParam.HTMLContent]: mappingObj.html,
    [SourceLayerParam.FillColor]: mappingObj.fillColor,
    [SourceLayerParam.StrokeColor]: mappingObj.strokeColor,
    [SourceLayerParam.Click]: mappingObj.clickUrl,
    [SourceLayerParam.Alt]: mappingObj.alt,
    [SourceLayerParam.Widget]: mappingObj.widget,
    [SourceLayerParam.Font]: mappingObj.font,
    [SourceLayerParam.QR]: mappingObj.qr,
    [SourceLayerParam.Subtitles]: mappingObj.subtitle,
  };

  if (!mappingObj) return null;

  return data[param] || null;
}

export default getMappingParam;
